export const BREAKPOINTS = {
  PHONE: 600,
  TABLET_PORTRAIT: 900,
  TABLET_LANDSCAPE: 1200,
  DESKTOP: 1800,
}

export const GUTTER = 20